import * as BABYLON from "@babylonjs/core/Legacy/legacy";

import { config } from "../config.js";
import { IMeshPool } from "./common.js";
import { GameScene } from "../scene";

const segmentSize = config.pathSegmentSize;
const log = console.log.bind(console);

export class BreakUpPathMeshPool implements IMeshPool {
	meshes: BABYLON.Mesh[];
	scene: GameScene;

	constructor(scene: GameScene) {
		this.meshes = [];
		this.scene = scene;
		this.createMeshes();
	}

	createMeshes() {
		let scene = this.scene;
		let matPing = new BABYLON.StandardMaterial(
			"break_mat_ping",
			scene.bbScene,
		);
		// mat.wireframe = true;
		matPing.diffuseTexture = scene
			.GetAsset()
			.loadTexture("./assets/aerial_rocks.jpg");
		matPing.specularColor = new BABYLON.Color3(0, 0, 0);

		let matXie = new BABYLON.StandardMaterial(
			"break_mat_xie",
			scene.bbScene,
		);
		// mat.wireframe = true;
		let tex = scene.GetAsset().loadTexture("./assets/aerial_rocks.jpg");
		tex.uScale = 2.0;
		tex.vScale = 2.0;
		matXie.diffuseTexture = tex;
		// matXie.diffuseColor = new BABYLON.Color3(0.8, 0.8, 0.8)
		matXie.specularColor = new BABYLON.Color3(0, 0, 0);

		let bumpTex = scene.GetAsset().loadTexture("./assets/rockn.png");
		bumpTex.uScale = 2.0;
		bumpTex.vScale = 2.0;
		matXie.bumpTexture = bumpTex;

		const createMesh = function () {
			// mPing
			var mPing = new BABYLON.Mesh("floor_break_ping", scene.bbScene);

			// 8 个顶点
			// 注意 y 轴是
			let unit = segmentSize / 2;
			let h = config.groundHeight;

			let len = 1.0;
			let hCoff = 1.0;
			var positions = [
				// 上面的 4 个点
				unit,
				h,
				unit,
				unit,
				h * hCoff,
				unit * len,
				-unit,
				h * hCoff,
				unit * len,
				-unit,
				h,
				unit,
			];

			// 右手法则决定法线的方向
			var indices = [
				// 上面的面
				0, 2, 1, 0, 3, 2,
			];

			var normals = [];
			BABYLON.VertexData.ComputeNormals(positions, indices, normals);

			let k = 0.3;
			var uvs = [1.0, k, 1.0, 0.0, 0.0, 0.0, 0.0, k];

			var vertexData = new BABYLON.VertexData();

			vertexData.positions = positions;
			vertexData.indices = indices;
			vertexData.normals = normals;
			vertexData.uvs = uvs;
			vertexData.applyToMesh(mPing);

			mPing.material = matPing;

			// 斜面
			var mXie = new BABYLON.Mesh("floor_break_xie", scene.bbScene);
			positions = [
				unit,
				h * hCoff,
				unit * len,
				unit,
				-h,
				-unit,
				-unit,
				-h,
				-unit,
				-unit,
				h * hCoff,
				unit * len,
			];
			indices = [
				// 上面的面
				0, 2, 1, 0, 3, 2,
			];
			normals = [];
			BABYLON.VertexData.ComputeNormals(positions, indices, normals);

			k = 1.0;
			var uvs = [1.0, k, 1.0, 0.0, 0.0, 0.0, 0.0, k];

			var vertexData = new BABYLON.VertexData();
			vertexData.positions = positions;
			vertexData.indices = indices;
			vertexData.normals = normals;
			vertexData.uvs = uvs;
			vertexData.applyToMesh(mXie);

			mXie.material = matXie;

			let m = BABYLON.Mesh.MergeMeshes(
				[mPing, mXie],
				true,
				true,
				undefined,
				false,
				true,
			);
			return m;
		};

		for (let i = 0; i < config.pathSegmentPreloadNum; i++) {
			// for (let i = 0; i < 1; i++) {
			let box1 = createMesh();
			this.meshes.push(box1);
		}
	}

	getMesh(): BABYLON.Mesh {
		// log('breakDown-getMesh')
		let res = this.meshes.pop();
		return res;
	}

	returnMesh(mesh: BABYLON.Mesh) {
		this.meshes.push(mesh);
	}
}

export class BreakDownPathMeshPool implements IMeshPool {
	pool: BreakUpPathMeshPool;
	constructor(scene: GameScene) {
		this.pool = new BreakUpPathMeshPool(scene);
	}

	getMesh(): BABYLON.Mesh {
		let res = this.pool.getMesh();
		res.rotation.y = Math.PI;
		return res;
	}

	returnMesh(mesh: BABYLON.Mesh) {
		this.pool.returnMesh(mesh);
	}
}
